module.exports = __webpack_public_path__ + "static/8.1_ancient_china-1ef914f9404a991b887900c9a90e23fb.pdf";